<template>
  <div class="add-product" style="background-color: white; padding: 15px">
    <el-form :label-position="labelPosition" :rules="rules" label-width="80px" :model="setting">
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="6" v-hasPerm="['promote:config:logo']">
          <div style="display: flow-root">
            <div style="margin-right: 8px">
              <div>{{ $t("promote.logo") }}</div>
              <div @click="mouseOver(1)" style="display: flex; align-items: center; cursor: pointer">
                <img src="/img/tips.png" style="width: 13px; margin-right: 3px" />
                <span style="font-size: 12px; color: #02a7f0">{{ $t("promote.Ps") }}</span>
              </div>
            </div>
            <el-form-item prop="logo" style="margin-bottom: 5px; margin-top: 5px">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="headers"
                :data="{ type: 0 }"
                accept=".jpg,.png"
                :show-file-list="true"
                :multiple="false"
                :limit="limit"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'logo', 0)"
                :on-exceed="(file, fileList) => handleExceed(file, fileList, 0)"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'logo', 0)"
                :on-error="(err, file, fileList) => handleError(err, file, fileList, 'logo', 0)"
                :before-upload="handleBeforeUpload"
                list-type="picture-card"
                :file-list="logolist"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="color: red; font-size: 12px">{{ $t("promote.Ssize") }}：200px * 52px</div>
        </el-col>
        <el-col :span="6" v-hasPerm="['promote:config:icon']">
          <div style="display: flow-root">
            <div style="margin-right: 8px">
              <div>{{ $t("promote.icon") }}</div>
              <div @click="mouseOver(2)" style="display: flex; align-items: center; cursor: pointer">
                <img src="/img/tips.png" style="width: 13px; margin-right: 3px" />
                <span style="font-size: 12px; color: #02a7f0">{{ $t("promote.Ps") }}</span>
              </div>
            </div>
            <el-form-item prop="icon" style="margin-bottom: 5px; margin-top: 5px">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="headers"
                :data="{ type: 0 }"
                accept=".ico"
                :show-file-list="true"
                :multiple="false"
                :limit="limit"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'icon', 1)"
                :on-exceed="(file, fileList) => handleExceed(file, fileList, 1)"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'icon', 1)"
                :on-error="(err, file, fileList) => handleError(err, file, fileList, 'icon', 1)"
                :before-upload="handleBeforeUpload"
                list-type="picture-card"
                :file-list="iconlist"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="color: red; font-size: 12px">{{ $t("promote.Ssize") }}：52px * 52px</div>
        </el-col>
        <el-col :span="6" v-hasPerm="['promote:config:himage']">
          <div style="display: flow-root">
            <div style="margin-right: 8px">
              <div>{{ $t("promote.homeSignImg") }}</div>
              <div @click="mouseOver(3)" style="display: flex; align-items: center; cursor: pointer">
                <img src="/img/tips.png" style="width: 13px; margin-right: 3px" />
                <span style="font-size: 12px; color: #02a7f0">{{ $t("promote.Ps") }}</span>
              </div>
            </div>
            <el-form-item prop="homeSignImg" style="margin-bottom: 5px; margin-top: 5px">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="{ type: 0 }"
                :headers="headers"
                accept=".jpg,.png"
                :show-file-list="true"
                :multiple="false"
                :limit="limit"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'homeSignImg', 2)"
                :on-exceed="(file, fileList) => handleExceed(file, fileList, 2)"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'homeSignImg', 2)"
                :on-error="(err, file, fileList) => handleError(err, file, fileList, 'homeSignImg', 2)"
                :before-upload="handleBeforeUpload"
                list-type="picture-card"
                :file-list="homeSignImglist"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="color: red; font-size: 12px">{{ $t("promote.Ssize") }}：500px * 378px</div>
        </el-col>
        <el-col :span="6" v-hasPerm="['promote:config:bgimage']">
          <div style="display: flow-root">
            <div style="margin-right: 8px">
              <div>{{ $t("promote.homeBackImg") }}</div>
              <div @click="mouseOver(4)" style="display: flex; align-items: center; cursor: pointer">
                <img src="/img/tips.png" style="width: 13px; margin-right: 3px" />
                <span style="font-size: 12px; color: #02a7f0">{{ $t("promote.Ps") }}</span>
              </div>
            </div>
            <el-form-item prop="homeBackImg" style="margin-bottom: 5px; margin-top: 5px">
              <el-upload
                class="upload-demo"
                :data="{ type: 0 }"
                :action="uploadUrl"
                :headers="headers"
                accept=".jpg,.png"
                :show-file-list="true"
                :multiple="false"
                :limit="limit"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'homeBackImg', 3)"
                :on-exceed="(file, fileList) => handleExceed(file, fileList, 3)"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'homeBackImg', 3)"
                :on-error="(err, file, fileList) => handleError(err, file, fileList, 'homeBackImg', 3)"
                :before-upload="handleBeforeUpload"
                list-type="picture-card"
                :file-list="homeBackImglist"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="color: red; font-size: 12px">{{ $t("promote.Ssize") }}：1920px * 1080px</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="6" v-hasPerm="['promote:config:startpca']">
          <div style="display: flow-root">
            <div style="margin-right: 8px">
              <div>{{ $t("promote.equipmentAnimation") }}</div>
            </div>
            <el-form-item prop="equipmentAnimation" style="margin-bottom: 5px; margin-top: 5px">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :data="{ type: 1 }"
                :headers="headers"
                accept=".zip"
                :multiple="false"
                :show-file-list="true"
                :limit="limit"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'equipmentAnimation', 6)"
                :on-exceed="(file, fileList) => handleExceed(file, fileList, 6)"
                :on-success="
                  (response, file, fileList) => handleSuccess(response, file, fileList, 'equipmentAnimation', 6)
                "
                :on-error="(err, file, fileList) => handleError(err, file, fileList, 'equipmentAnimation', 6)"
                :before-upload="handleBeforeUpload"
                :file-list="equipmentAnimationlist"
              >
                <el-button size="small" type="primary">{{ $t("promote.Config.656105-0") }}</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red; font-size: 12px; line-height: 13px">
                  {{ $t("promote.imgZipType") }}
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6" v-hasPerm="['promote:config:bottomlogo']">
          <div style="display: flow-root">
            <div style="margin-right: 8px">
              <div>{{ $t("promote.homeDownImg") }}</div>
              <div @click="mouseOver(5)" style="display: flex; align-items: center; cursor: pointer">
                <img src="/img/tips.png" style="width: 13px; margin-right: 3px" />
                <span style="font-size: 12px; color: #02a7f0">{{ $t("promote.Ps") }}</span>
              </div>
            </div>
            <el-form-item prop="homeDownImg" style="margin-bottom: 5px; margin-top: 5px">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="headers"
                :data="{ type: 0 }"
                accept=".jpg,.png"
                :show-file-list="true"
                :multiple="false"
                :limit="limit"
                :on-remove="(file, fileList) => handleRemove(file, fileList, 'homeDownImg', 4)"
                :on-exceed="(file, fileList) => handleExceed(file, fileList, 4)"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 'homeDownImg', 4)"
                :on-error="(err, file, fileList) => handleError(err, file, fileList, 'homeDownImg', 4)"
                :before-upload="handleBeforeUpload"
                list-type="picture-card"
                :file-list="homeDownImglist"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div style="color: red; font-size: 12px">{{ $t("promote.Ssize") }}：130px * 52px</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-bottom: 10px">
        <el-col :span="12" v-hasPerm="['promote:config:logolink']">
          <el-form-item :label="$t('promote.logoUrl')" prop="logoUrl">
            <el-input v-model="setting.logoUrl" :placeholder="$t('promote.logoUrlEntry')" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-hasPerm="['promote:config:bottomtext']">
        <el-col :span="24">
          <el-form-item :label="$t('promote.equipmentDownText')" prop="homeDownText">
            <div
              @click="mouseOver(6)"
              style="display: flex; align-items: center; cursor: pointer; width: 150px; margin-bottom: 10px"
            >
              <img src="/img/tips.png" style="width: 13px; margin-right: 3px" />
              <span style="font-size: 12px; color: #02a7f0">{{ $t("promote.Ps") }}</span>
            </div>
            <el-tiptap
              v-model="setting.homeDownText"
              :extensions="extensions"
              :lang="this.$i18n.locale == 'zh_CN' ? 'zh' : this.$i18n.locale == 'en_US' ? 'en' : 'en'"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary" :disabled="loadingForm || uploadCount > 0" @click="submitForm" style="margin-top: 90px">{{
      $t("promote.save")
    }}</el-button>
    <el-dialog :modal-append-to-body="true" :append-to-body="true" :visible.sync="showImag" width="50%">
      <img :src="showImage" style="width: 100%; margin-top: 10px" />
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/http/config";
  import {
    // 需要的 extensions
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    Strike,
    ListItem,
    BulletList,
    OrderedList,
    Link,
    Image,
    CodeBlock,
    Blockquote,
    TodoItem,
    TodoList,
    TextAlign,
    FontSize,
    FontType,
    Fullscreen,
    TextHighlight,
    TextColor,
    FormatClear,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    History,
    TrailingNode,
    HardBreak,
    HorizontalRule,
    LineHeight,
    Indent
  } from "element-tiptap";
  export default {
    name: "PromoteConfig",
    data() {
      return {
        labelPosition: "top",
        limit: 1,
        uploadUrl: config.baseUrl + this.$url.Upload.setting,
        headers: {
          token: this.$cookies.get("token")
        },
        loadingForm: false,
        setting: {
          logo: "",
          icon: "",
          homeSignImg: "",
          homeBackImg: "",
          homeDownImg: "",
          equipmentAnimation: "",
          logoUrl: ""
        },
        logolist: [],
        iconlist: [],
        homeSignImglist: [],
        homeBackImglist: [],
        homeDownImglist: [],
        uploadCount: 0,

        equipmentAnimationlist: [],
        showImag: false,
        showImage: "",
        yesNo: [],
        extensions: [
          new Doc(), // 必须项
          new Text(), // 必须项
          new Paragraph(), // 必须项
          new Heading({ level: 6 }), // 标题
          new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
          new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
          new Italic({ bubble: true }), // 斜体
          new Strike({ bubble: true }), // 删除线
          new ListItem(), // 使用列表必须项
          new BulletList({ bubble: true }), // 无序列表
          new OrderedList({ bubble: true }), // 有序列表
          new Link(), // 链接
          new Image(), // 图片
          new CodeBlock({ bubble: true }), // 代码块
          new Blockquote(), // 引用
          new TodoItem(), // 任务列表必须项
          new TodoList(), // 任务列表
          new TextAlign({ bubble: true }), // 文本对齐方式
          new FontSize({ bubble: true }), // 字号
          new FontType({ bubble: true }), // 字体
          new Fullscreen(), // 全屏
          new TextHighlight({ bubble: true }), // 文本高亮
          new TextColor({ bubble: true }), // 文本颜色
          new FormatClear({ bubble: true }), // 清除格式
          new Table({ resizable: true }), // 表格
          new TableHeader(), // 表格必须项
          new TableCell(), // 表格必须项
          new TableRow(), // 表格必须项
          new History(), // 撤销
          new TrailingNode(), // 重做
          new HardBreak(), // 分割线
          new HorizontalRule(), // 行距
          new LineHeight(), // 增加缩进
          new Indent() // 减少缩进
        ]
      };
    },
    mounted() {
      let _self = this;
      let url = _self.$url.Promote.get;
      let method = _self.$method.get;
      _self.$api
        .request(url, method, {
          type: "LOGO"
        })
        .then(res => {
          if (res.code === 0) {
            _self.setting = res.data;
            _self.showsetting = res.data;
            if (res.data.logo) {
              let obj = {
                name: res.data.logo,
                url: res.data.logo
              };
              _self.logolist.push(obj);
              let card = window.document.querySelectorAll(".el-upload--picture-card");
              card[0].style.display = "none";
            } else {
              _self.logolist = [];
            }
            if (res.data.icon) {
              let obj = {
                name: res.data.icon,
                url: res.data.icon
              };
              _self.iconlist.push(obj);
              let card = window.document.querySelectorAll(".el-upload--picture-card");
              card[1].style.display = "none";
            } else {
              _self.iconlist = [];
            }
            if (res.data.homeSignImg) {
              let obj = {
                name: res.data.homeSignImg,
                url: res.data.homeSignImg
              };
              _self.homeSignImglist.push(obj);
              let card = window.document.querySelectorAll(".el-upload--picture-card");
              card[2].style.display = "none";
            } else {
              _self.homeSignImglist = [];
            }
            if (res.data.homeBackImg) {
              let obj = {
                name: res.data.homeBackImg,
                url: res.data.homeBackImg
              };
              _self.homeBackImglist.push(obj);
              let card = window.document.querySelectorAll(".el-upload--picture-card");
              card[3].style.display = "none";
            } else {
              _self.homeBackImglist = [];
            }
            if (res.data.homeDownImg) {
              let obj = {
                name: res.data.homeDownImg,
                url: res.data.homeDownImg
              };
              _self.homeDownImglist.push(obj);
              let card = window.document.querySelectorAll(".el-upload--picture-card");
              card[4].style.display = "none";
            } else {
              _self.homeDownImglist = [];
            }

            if (res.data.equipmentAnimation) {
              let obj = {
                name: res.data.equipmentAnimation,
                url: res.data.equipmentAnimation
              };
              _self.equipmentAnimationlist.push(obj);
              let card = window.document.querySelectorAll(".el-upload--text");
              card[0].style.display = "none";
            } else {
              _self.equipmentAnimationlist = [];
              let card = window.document.querySelectorAll(".el-upload--text");
              if (card.length <= 0) return;
              card[0].style.display = "inline-block";
            }
            _self.getYesNo();
          }
        })
        .catch(err => {
          _self.$notify({
            title: _self.$t("common.tip"),
            message: err.msg,
            type: "error"
          });
        });
    },
    methods: {
      // 动态设置网站icon
      setFavicon(iconURL) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = iconURL;
      },
      getYesNo() {
        let _self = this;
        _self.$api.dict("sys_yes_no").then(res => {
          if (res.code === 0) {
            _self.yesNo = res.data;
          }
        });
      },
      mouseOver(index) {
        let _self = this;
        _self.showImag = true;
        _self.showImage = "/img/" + index + ".png";
      },
      submitForm() {
        let _self = this;
        _self.loadingForm = true;
        let url = _self.$url.Promote.save;
        let method = _self.$method.post;
        console.log(this.$t("promote.Config.656105-1"), _self.setting);
        _self.$api
          .request(url, method, {
            type: "LOGO",
            content: JSON.stringify(_self.setting)
          })
          .then(res => {
            if (res.code === 0) {
              this.setFavicon(_self.setting.icon);
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "success"
              });
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "error"
              });
            }
            _self.loadingForm = false;
          })
          .catch(err => {
            _self.loadingForm = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  移除触发
      handleRemove(file, fileList, field, i) {
        let _self = this;
        console.log(this.$t("promote.Config.656105-2") + file, fileList, field, i);
        // 需要在上传文件中删除本项  不然会造成无法删除的bug
        delete _self.setting[field];
        // If file status is 'uploading', decrement count
        if (file && file.status === "uploading") {
          if (_self.uploadCount > 0) {
            _self.uploadCount--;
          }
        }
        _self.showUpload("", i);
      },
      //  文件超出个数限制时的钩子
      handleExceed(file, fileList, i) {
        console.log(this.$t("promote.Config.656105-3") + file, fileList, i);
      },
      // 文件上传成功时的钩子
      handleSuccess(response, file, fileList, field, i) {
        let _self = this;
        console.log(this.$t("promote.Config.656105-4"), field);
        if (response.code === 0) {
          _self.setting[field] = response.data;
          console.log(_self.setting[field], 11, _self.setting, field);
          _self.$message.success(response.msg);
          _self.$nextTick(() => {
            // Fix selector for equipment animation (index 6)
            if (i === 6) {
              let card = window.document.querySelectorAll(".el-upload--text");
              if (card.length > 0) {
                card[0].style.display = "none";
              }
            } else {
              let card = window.document.querySelectorAll(".el-upload--picture-card");
              if (card.length > i) {
                card[i].style.display = "none";
              }
            }
          });
        } else {
          _self.$message({
            message: response.msg,
            type: "warning",
            dangerouslyUseHTMLString: true // 允许使用HTML字符串
          });
          delete _self.setting[field];
          _self[field + "list"] = [];
          // Ensure upload element is visible again on failure if needed for retry
          _self.showUpload("", i);
        }
        // Decrement count on success/failure
        if (_self.uploadCount > 0) {
          _self.uploadCount--;
        }
      },
      // 文件上传失败时的钩子
      handleError(err, file, fileList, field, i) {
        let _self = this;
        _self.hideUpload(i, field); // This seems to clear the setting field, might be okay
        _self.$message.error(err.msg ? err.msg : _self.$t("addProduct.error"));
        // Decrement count on error
        if (_self.uploadCount > 0) {
          _self.uploadCount--;
        }
        // Ensure upload element is visible again on failure
        _self.showUpload("", i);
      },
      hideUpload(i, field) {
        let _self = this;
        _self.setting[field] = "";
        _self.$nextTick(() => {
          let card = window.document.querySelectorAll(".el-upload--picture-card");
          card[i].style.display = "none";
        });
      },
      showUpload(boo, i) {
        let _self = this;
        if (i == 6) {
          _self.$nextTick(() => {
            let card = window.document.querySelectorAll(".el-upload--text");
            card[0].style.display = "inline-block";
          });
        } else {
          _self.$nextTick(() => {
            let card = window.document.querySelectorAll(".el-upload--picture-card");
            card[i].style.display = "inline-block";
          });
        }
      },
      // Add before-upload handler
      handleBeforeUpload() {
        this.uploadCount++;
        return true; // Return true to allow upload
      }
    }
  };
</script>

<style lang="scss">
  .el-dialog__body {
    height: auto;
  }

  .editor {
    height: 370px;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
</style>
